import HttpStatus from 'http-status-codes';
import ReportableException from './ReportableException';
import UnauthenticatedException from './UnauthenticatedException';
import UnprocessableException from './UnprocessableException';

export default class RequestExceptionFactory {
  static fromHttpResponse = async (httpResponse) => {
    const jsonResponse = await httpResponse.json();
    switch (httpResponse.status) {
      case HttpStatus.CONFLICT:
        return new ReportableException(jsonResponse);
      case HttpStatus.BAD_REQUEST:
        // Manejar errores 400 como ReportableException para mostrar mensajes específicos
        return new ReportableException(jsonResponse);
      case HttpStatus.UNPROCESSABLE_ENTITY:
        return new UnprocessableException(jsonResponse);
      case HttpStatus.NOT_FOUND:
        // Si el 404 contiene errores de validación, tratarlo como UnprocessableException
        if (jsonResponse?.response?.error || jsonResponse?.response?.errorArray) {
          return new UnprocessableException(jsonResponse);
        }
        return new ReportableException(jsonResponse);
      case HttpStatus.UNAUTHORIZED:
        return new UnauthenticatedException(jsonResponse);
      default:
        return Error(httpResponse.statusText);
    }
  };
}
